export default __webpack_public_path__ + "locales/ar-SA/InfoPanel.json?hash=979f19f40cf28628e10833ac85359039";